<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import BannerService from '../../../../domain/banner/services/banner'
  import { isEmpty } from 'lodash'

  export default {
    nome: 'novo-banner',
    directives: {mask},
    data () {
      return {
        banner: {
          nome: '',
          posicao: 0,
          dataExibicao: '',
          dataExpiracao: '',
          situacao: true,
          hasVideo: false,
          url: ''
        },
        dataExibicao: '',
        horaExibicao: '',
        dataExpiracao: '',
        horaExpiracao: '',
        isLoading: false,
        isUpdating: false,
        updateImg: false,
        urlImg: '',
        formData: null,
        errorMsg: '',
        arquivo: ''
      }
    },
    computed: {
      dataExib () {
        return this.dataExibicao.replace(/-/g, '/') + ' ' + this.horaExibicao + ':00'
      },
      dataExp () {
        return this.dataExpiracao.replace(/-/g, '/') + ' ' + this.horaExpiracao + ':00'
      },
      areDatesValid () {
        return (new Date(this.dataExib) < new Date(this.dataExp))
      },
      notEmptyDates () {
        return !isEmpty(this.dataExibicao) && !isEmpty(this.horaExibicao) && !isEmpty(this.dataExpiracao) && !isEmpty(this.horaExpiracao)
      },
      isBannerValid () {
        return !isEmpty(this.banner.nome) && this.notEmptyDates
      },
      isValid () {
        return this.areDatesValid && this.isBannerValid // && (this.updateImg && this.formData !== null)
      }
    },
    beforeMount () {
      this.getBanner()
    },
    mounted () {
      console.log(process.env.API_URL)
      this.$refs.inptNome.focus()
    },
    activated () {
    },
    destroyed () {
    },
    methods: {
      getBanner () {
        this.isLoading = true
        BannerService.getBanner(this.$route.params.id)
          .then(result => {
            console.log(result.data)
            this.banner = result.data
            let tmp = this.convertDataHora(this.banner.dataExibicao.date)
            this.dataExibicao = tmp[0]
            this.horaExibicao = tmp[1]
            tmp = this.convertDataHora(this.banner.dataExpiracao.date)
            this.dataExpiracao = tmp[0]
            this.horaExpiracao = tmp[1]
            tmp = null
          })
      },
      convertDataHora (date) { // TODO: MELHORAR
        // "2018-06-30 14:30:00.000000"
        let tmp = date.split(' ')
        let data = tmp[0]
        let hora = tmp[1].match(/^\d{2}:\d{2}/)
        return [data, hora[0]]
      },
      abreFileInput () {
        this.$refs.uploadFile.click()
      },
      setFile (event) {
        let arquivo = event.target.files[0]
        let formData = new FormData()

        formData.append('file', arquivo, arquivo.name)

        this.formData = formData
        this.arquivo = arquivo.name

        console.log('arquivo', arquivo)
        console.log('formdata', formData)
        document.getElementById('fileInpt').value = ''
      },
      updateBanner () {
        this.isUpdating = true
        this.isLoading = true
        this.errorMsg = ''
        this.banner.dataExibicao = this.dataExib
        this.banner.dataExpiracao = this.dataExp
        BannerService.updateBanner(this.$route.params.id, this.banner)
          .then(result => {
            if (this.formData) {
              this.updateFoto(result.data.id)
            } else {
              this.isUpdating = false
              this.reset()
              this.$router.push({name: 'banners.lista', query: {sucesso: 1}})
            }
          })
          .catch(error => {
            console.log('erro banner', error.response.data.error)
          })
      },
      updateFoto (id) {
        BannerService.updateFoto(this.formData, id)
          .then(result => {
            console.log(result.data)
            this.isUpdating = false
            let tmp = this.url
            let d = new Date()
            this.url = ''
            this.url = tmp + '?' + d.getTime()
            this.reset()
            this.$router.push({name: 'banners.lista', query: {sucesso: 1}})
          })
          .catch(error => {
            console.log('erro aqui', error.response.data.error)
            if (error.response.status === 400) {
              this.isUpdating = false
              this.errorMsg = 'Houve um erro com a imagem. Tente novamente'
              this.erro = error.response.data.errors
            }
          })
      },
      loading (v) {
        this.isLoading = !!v
      },

      nextElement ({target}) {
        let index = parseInt(target.getAttribute('tabindex'))
        let next = index + 1
        document.querySelector('[tabindex="' + next + '"').focus()
      },
      resetImg () {
        this.arquivo = ''
        this.formData = null
      },
      reset () {
        this.banner = {
          nome: '',
          posicao: 0,
          dataExibicao: '',
          dataExpiracao: '',
          situacao: true,
          hasVideo: false,
          url: ''
        }
        this.dataExibicao = ''
        this.horaExibicao = ''
        this.dataExpiracao = ''
        this.horaExpiracao = ''
        this.isLoading = false
        this.isUpdating = false
        this.resetImg()
      },
      cancel () {
        this.reset()
        this.$router.push({ name: 'banners.lista' })
      }
    }
  }
</script>

<template>
  <div>
    <div class="app-content-body ">
      <div class="bg-light lter b-b wrapper-md">
        <h1 class="m-n font-thin h3">Cadastro de Banner</h1>
      </div>
      <span class="info-msg" v-if="isUpdating && !errorMsg">{{ isUpdating ? 'Cadastrando banner...' : '' }}</span>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <form @submit.prevent="">
            <div class="form-group wrapper-md">
              <div class="row m-b-md">
                <div class="col-md-8">
                  <label for="nome" ref="inptNome" class="control-label">Nome</label>
                  <input id="nome" type="text" class="form-control" v-model="banner.nome">
                </div>
                <div class="col-md-4">
                  <label for="posicao" class="control-label">Posição do banner</label>
                  <input id="posicao" type="number" min="0" name="account" class="form-control m-b" v-model.number="banner.posicao">
                </div>
              </div><!-- Fim Row -->
              <div class="row m-b-md">
                <div class="col-md-8">
                  <label for="url" class="control-label">Url</label>
                  <input id="url" type="text" class="form-control" placeholder="http://example.com" v-model="banner.url">
                </div>
              </div><!-- Fim Row -->
              <div class="row m-b-md">
                <div class="col-md-3">
                  <label for="dataExibicao" class="control-label">Data Exibição</label>
                  <input id="dataExibicao" type="date" class="form-control" v-model="dataExibicao">
                </div>
                <div class="col-md-3">
                  <label for="horarioExibicao" class="control-label">Horário Exibição</label>
                  <input id="horarioExibicao" type="time" class="form-control" v-model="horaExibicao">
                </div>
                <div class="col-md-3">
                  <label for="dataExpiracao" class="control-label">Data Expiração</label>
                  <input id="dataExpiracao" type="date" class="form-control" v-model="dataExpiracao">
                </div>
                <div class="col-md-3">
                  <label for="horarioExpiracao" class="control-label">Horário Expiração</label>
                  <input id="horarioExpiracao" type="time" class="form-control" v-model="horaExpiracao">
                </div>
              </div>
              <div class="row m-b-md" style="margin-left: 0px" v-if="!areDatesValid && notEmptyDates"><span class="text-red">Data/hora de expiração deve ser superior à de exibição</span></div>
              <div class="row m-b-md">
                <div class="col-md-4">
                  <label for="situacao" class="control-label">Situação</label>
                  <select id="situacao" name="account" class="form-control m-b" v-model="banner.situacao">
                    <option :value="true">Ativo</option>
                    <option :value="false">Inativo</option>
                  </select>
                </div>
                <div class="col-md-4 m-t-md">
                  <div class="checkbox">
                    <label class="i-checks">
                      <input type="checkbox" v-model="banner.hasVideo"><i></i> Este banner contém vídeo ?
                    </label>
                  </div>
                </div>
                <div class="col-md-4 m-t-md">
                  <button class="btn btn-success" @click="abreFileInput" :disabled="isUpdating">Alterar imagem</button>
                  <div>Arquivo selecionado: <strong>{{ arquivo }}</strong></div>
                  <span v-if="!formData">(deixe em branco se não deseja alterar)</span>
                  <button class="btn btn-default btn-sm" @click="resetImg" v-else>Limpar imagem</button>
                  <input type="file" id="fileInpt" ref="uploadFile" accept="image/*" v-show="false" @change="setFile($event)"><br>
                  <span class="text-red" v-if="!errorMsg">{{ errorMsg }}</span>
                </div>
              </div><!-- Fim Row -->
              <div class="row m-b-xs">

              </div><!-- Fim Row -->
              <hr>
              <div class="wrapper-md">
                <div class="row">
                  <button class="btn w-xs btn-info" type="button" @click="updateBanner()" :disabled="isUpdating || !isValid">{{ isUpdating ? 'Aguarde...' : 'Atualizar' }}</button>
                  <button class="btn w-xs m-r-md btn-default" @click="cancel()">Cancelar</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .info-msg {
    background-color: khaki;
    padding: 5px 15px;
    display: block;
    text-align: center;
  }
  .text-red {
    color: #f00;
  }
</style>



// WEBPACK FOOTER //
// UpdateBanner.vue?14eea19e